export default __webpack_public_path__ + "static/media/spartan-controls.e2b0dae0.png";